module.exports = __webpack_public_path__ + "img/ifast.0495cbb1.png";